export const ACTION_CODE = 'EXPENSE_TYPE' + '_ACTION';
